import React, { Component } from 'react';
import $ from 'jquery';

import 'jszip/dist/jszip.min.js';
import 'datatables.net-dt/css/jquery.dataTables.css';
import 'datatables.net-buttons-dt/css/buttons.dataTables.css';
import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.flash.js';
import 'datatables.net-buttons/js/buttons.print.js';

/**
 *
 * DataTable component
 *
 * Using: https://datatables.net/download/npm
 *
 */
export default class DataTable extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    this.buildTable();
  }

  /**
   * Params:
   *
   * 1. tableId: Unique table ID used to render datatable
   * 2. sortOrder: Accepts an array of column index and sort order e.g. [0, 'desc']
   *
   */
  buildTable() {
    const { tableId, sortOrder } = this.props;

    let datatableId = '#' + tableId;

    if (typeof tableId === 'undefined') {
      console.warn('DataTable component requires a tableId to initialize');
    } else {
      // let columns = $(tableId + " thead th");
      //const { children }= this.props;
      $(datatableId).DataTable({
        dom: 'Bfrtip',
        paging: false,
        buttons: ['copy', 'csv', 'print'],
        aaSorting: sortOrder ? sortOrder : []
      });

      // let columnData = table.columns(columns).data();
      // console.info(columnData);
    }
  }

  render() {
    const {
      tableId,
      columnTitles,
      children,
      onClickNext,
      onClickPrev
    } = this.props;

    return (
      <div className="table-wrapper">
        <table className="datatable table table-striped" id={tableId}>
          <thead>
            <tr>
              {typeof columnTitles !== 'undefined' ? (
                columnTitles.map((title, index) => {
                  return (
                    <th key={index} title={'Click to sort by ' + title}>
                      {title}
                    </th>
                  );
                })
              ) : (
                <th>-</th>
              )}
            </tr>
          </thead>
          <tbody>{children}</tbody>
        </table>
        <ul className="pagination pull-right">
          {this.props.previous !== '' ? (
            <li>
              <button onClick={onClickPrev} className="btn btn-default">
                Previous
              </button>
            </li>
          ) : null}
          {this.props.next !== '' ? (
            <li>
              <button className="btn btn-primary" onClick={onClickNext}>
                Next
              </button>
            </li>
          ) : null}
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DataTable2.jsx